<template>
    <h1>Pedidos de Ausência</h1>
    <AbsenceRequestIndexTable />
</template>

<script setup>

import AbsenceRequestIndexTable from '@/components/absences/requests/AbsenceRequestIndexTable.vue';
</script>

<style scoped>

</style>